import router from './router';
import { ProcessingProvider } from '@/school-management/context/ProcessingContext';

import { RouterProvider } from 'react-router-dom';
import { DrawerProvider } from './context/DrawerContext';

const System = () => {
  return (
    <DrawerProvider>
      <ProcessingProvider>
        <RouterProvider router={router}></RouterProvider>
      </ProcessingProvider>
    </DrawerProvider>
  );
};

export default System;
